module.exports = __webpack_public_path__ + "static/media/waitlist-member-1.73d4042e.jpeg";